import { Card, CardBody, Col, Row } from "reactstrap";
import { P } from "../../../AbstractElements";
import ServiceCard from "./ServiceCard";

type Props = { id: string };

export default function ServiceHistory({ id }: Props) {
  return (
    <Card>
      <CardBody>
        <Col>
          <Row>
            <ServiceCard userId={id} />
          </Row>
        </Col>
      </CardBody>
    </Card>
  );
}
